<template>
  <div class="flex items-center justify-center h-full" @click="openModal">
    {{courseList.length}}

    <!-- Modal -->
    <div v-if="showCourseListModal">
      <vs-popup
        class="holamundo"
        title="Enrolled Courses"
        :active.sync="showCourseListModal"
      >
        <vs-table :data="courseList" class="cstm_vuexy_table">
          <template slot="thead">
            <vs-th>Course Name</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ data[indextr].name }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CoursesListAction',
  data () {
    return {
      showCourseListModal: false,
      courseList: []
    }
  },
  mounted () {
    this.params.data.enrolled_courses.forEach(ele => {
      if (Object.keys(ele).length > 0) {
        this.courseList = this.courseList.concat(ele)
      }
    })
  },
  methods: {
    openModal () {
      this.showCourseListModal = true
    },
    closeModal () {
      this.showCourseListModal = false
    }
  }
}
</script>
